import Menu from "./menu";
import {gsap} from "gsap";
import Utils from '../utils/utils';
import emitter from 'tiny-emitter/instance';

class Navbar{


  constructor()
  {
    this.lastPos
    this.currentPos
    this.isSuBMenuOpen = false
    this.header = document.querySelector('.navbar')
    this.defaultLogo = document.querySelector('.navbar-logo--default')
    this.scrollLogo = document.querySelector('.navbar-logo--scroll')
    this.navItem = document.querySelectorAll('.menu-item-has-children')
    this.subMenu = document.querySelectorAll('.sub-menu')
    this.menuItems = document.querySelector('.navbar-menu > ul')
    this.navItem.forEach((item) => {
      let div = document.createElement("div");
      div.classList.add("sub-menu__arrow");
      item.insertBefore(div, item.children[1]);

      if(Utils.isMobile()) {

        this.addMobileStickyNabvarHandler = this.addMobileStickyNabvar.bind(this)
        this.removeMobileStickyNabvarHandler = this.removeMobileStickyNavbar.bind(this)
        emitter.on('mobileNavbar::show', this.addMobileStickyNabvarHandler)
        emitter.on('mobileNavbar::hide', this.removeMobileStickyNabvarHandler)

        item.addEventListener('click', (e) => {
          let items = []
          for (let i = 0; i < this.menuItems.children.length; i++) {
            if(this.menuItems.children[i] !== item) {
              items.push(this.menuItems.children[i])
            }
          }
          let subMenu = item.querySelector('.sub-menu')
          if(e.target.nextElementSibling !== null) {
            if(!this.isSuBMenuOpen) {
              gsap.to(items, {x: -500, display: 'none'})
              gsap.fromTo(subMenu, {x: 500, display: 'none'}, {x: 0, display: 'block'})
              item.classList.add('menu-item--open')
              this.isSuBMenuOpen = true
            } else {
              gsap.to(subMenu, {x:500, display: 'none'})
              gsap.to(items, {x:0, display: 'block', delay: .5})
              item.classList.remove('menu-item--open')
              this.isSuBMenuOpen = false
            }
          }
        })
      }
    })
    this.openMenu = null
    this.openArrow = null
    if(!Utils.isMobile()) {
      this.bindEvents()
    }
  }


  bindEvents()
  {
    window.addEventListener('scroll',this.onScroll.bind(this))
  }

  addMobileStickyNabvar() {
    this.header.classList.add("navbar-sticky")
    this.header.classList.add("mobile-navbar--blue")
  }

  removeMobileStickyNavbar() {
    this.header.classList.remove("navbar-sticky")
    this.header.classList.remove("mobile-navbar--blue")
  }


  onScroll()
  {

    this.currentPos = window.scrollY

    /** home section **/
    /** scroll up limit **/
    if (this.lastPos > this.currentPos && this.currentPos < 50 ) {
      // console.log("scroll up")

      this.header.classList.remove("navbar-sticky")
    }

    /** scroll down limit **/
    if (this.lastPos < this.currentPos && this.currentPos > 50 && (window.innerHeight + this.currentPos)) {
      // console.log("scroll down")
      this.header.classList.add("navbar-sticky")
    }

    this.lastPos = this.currentPos

  }
}
export default Navbar;



// WEBPACK FOOTER //
// ./scripts/interface/navbar.js